/**
 * @param conditionFn function to check condition
 * @param pollingTime time intervall in ms to wait between checks
 * @returns promise, resolving after `conditionFn` returns/resolves to true
 * @todo add timeout parameter
 */
export async function waitForCondition(conditionFn: (...args: unknown[]) => unknown | Promise<unknown>, pollingTime = 10): Promise<void> {
    while (true) {
        try {
            if (!!(await conditionFn())) {
                return;
            }
        } catch (_e) {}

        await new Promise(res => setTimeout(res, pollingTime));
    }
}
